// import React, { useState } from 'react'
// import { Link, Navigate, useLocation, useNavigate } from "react-router-dom"
// import { toast } from 'react-toastify'
// import { api_url } from '../constant'

// import logo from '../images/logo.png'
// import main from '../images/main.png'
// import { useAuth } from '../store/authProvider'
// import ReactGA from "react-ga4";
// import { Helmet } from "react-helmet";
// import PasswordResetModal from './PasswordResetModal'; // Import the modal

// function Signin(props) {
//   ReactGA.send({
//     hitType: "pageview",
//     page: window.location.pathname,
//     title: "Signin Page",
//   });

//   const [phones, setPhone] = useState('')
//   const [val, setVal] = useState(phones);
//   const [password, setPassword] = useState('')
//   const { isAuth, setToken } = useAuth()
//   const navigate = useNavigate()
//   const location = useLocation()

//   // Password reset modal state
//   const [showResetModal, setShowResetModal] = useState(false);

//   const login = async () => {
//     try {
//       // Format phone number if it starts with 0
//       let formattedPhone = phones;
//       if (phones.startsWith('0')) {
//         formattedPhone = "+249" + phones.substring(1);
//       }

//       const response = await fetch(api_url + "/auth/login", {
//         method: "POST",
//         body: JSON.stringify({
//           phonenumber: formattedPhone,
//           password: password
//         }),
//         headers: { 'Content-Type': 'application/json' }
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         // Show Arabic error message regardless of backend response
//         toast.error("رقم الهاتف أو كلمة المرور غير صحيحة", {
//           position: "top-center",
//           autoClose: 5000,
//         });
//         return;
//       }

//       // Successful login
//       setToken(data.access_token);
//       localStorage.setItem("auth", "true");
//       localStorage.setItem("user_id", data.user_id);
//       localStorage.setItem("type", data.type);
//       localStorage.setItem("cooperativeType", data.cooperativeType);
//       localStorage.setItem("isVerified", data.isVerified);

//       if (location.state?.from) {
//         navigate(location.state.from)
//       }
//       window.location.reload();

//     } catch (error) {
//       // Handle network errors or other exceptions
//       toast.error("حدث خطأ أثناء محاولة تسجيل الدخول", {
//         position: "top-center",
//         autoClose: 5000,
//       });
//       console.error("Login error:", error);
//     }
//   };

//   // Handle forget password - show modal
//   const handleForgetPassword = () => {
//     setShowResetModal(true);
//   };

//   if (isAuth) {
//     return <Navigate replace to="/"></Navigate>
//   }

//   return (
//     <>
//       <Helmet>
//         ‍<title>تسجيل الدخول</title>‍
//         <meta property="og:site_name" content="Mahsool" />
//         <meta name="keywords" content="Mahsool" />
//         <meta property="og:title" content="تسجيل الدخول" />
//         <meta property="og:description" content="mahsool" />
//         <meta property="og:locale" content="en_US" />
//         <meta property="og:type" content="website" />
//       </Helmet>
//       <div className="flex bg-flipped-background bg-no-repeat bg-right-bottom bg-60% lg:bg-50%">
//         <div className="hidden lg:block">
//           <img src={main} alt="" className="h-screen" />
//         </div>

//         <div className="w-full lg:w-auto lg:mx-auto">
//           <div className="flex flex-col p-4 lg:p-0 lg:w-[26.313rem] gap-3 items-center justify-center h-screen mx-auto">
//             <img src={logo} alt="" className="w-16" />
//             <div className="font-bold italic">
//               بوابتك للمعلومات و الاسواق الزراعية
//             </div>

//             <div className=""></div>
//             <div className="flex flex-col text-right justify-center w-full lg:w-[26.313rem]">
//               <form id="phone" action="" className="flex flex-col gap-3 mb-3">
//                 <label className="font-bold">رقم الهاتف</label>
//                 <input
//                   className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0 focus:border-primary"
//                   dir="rtl"
//                   pattern="[+]*?[0-9]*"
//                   value={val}
//                   onChange={(e) => {
//                     setPhone(e.target.value);
//                     setVal((v) =>
//                       e.target.validity.valid ? e.target.value : v
//                     );
//                   }}
//                   placeholder="إدخل رقم الهاتف (09xxxxxx)"
//                   type="text"
//                 />
//               </form>
//               <form id="phone" action="" className="flex flex-col gap-3">
//                 <label className="font-bold">كلمة المرور</label>
//                 <input
//                   className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0 focus:border-primary"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="أدخل كلمة المرور"
//                   type="password"
//                   dir="rtl"
//                 />

//                 {/* Forget Password Link */}
//                 <div className="text-left mt-2">
//                   <button
//                     type="button"
//                     onClick={handleForgetPassword}
//                     className="text-primary hover:text-blue-700 text-sm font-medium underline transition-colors duration-200"
//                   >
//                     نسيت كلمة المرور؟
//                   </button>
//                 </div>
//               </form>
//               <button
//                 onClick={() => login()}
//                 className="w-full h-[47px] font-bold text-white rounded-[13.539px] bg-primary hover:bg-blue-700 transition-colors"
//               >
//                 تسجيل الدخول
//               </button>
//             </div>

//             <div className="relative flex flex-col w-full text-center gap-3">
//               <p className="text-[#999797] text-sm">ليس لديك حساب؟</p>
//               <Link to="/signup">
//                 <button className="w-full h-[47px] font-bold text-primary border-primary border-2 rounded-[13.539px] hover:bg-primary hover:text-white transition-colors">
//                   إنشاء حساب
//                 </button>
//               </Link>
//               <p className="text-[#999797] text-sm">أو</p>
//               <Link to="/">
//                 <button className="w-full h-[47px] font-bold text-primary border-primary border-2 rounded-[13.539px] hover:bg-primary hover:text-white transition-colors">
//                   تسجيل دخول كزائر
//                 </button>
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Password Reset Modal */}
//       <PasswordResetModal
//         isOpen={showResetModal}
//         onClose={() => setShowResetModal(false)}
//         initialPhone={phones} // Pass the phone number from login form
//       />
//     </>
//   );
// }

// export default Signin;
import React, { useState } from 'react'
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { api_url } from '../constant'

import logo from '../images/logo.png'
import main from '../images/main.png'
import { useAuth } from '../store/authProvider'
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";
import PasswordResetModal from './PasswordResetModal';

function Signin(props) {
  const { t, i18n } = useTranslation();
  
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Signin Page",
  });

  const [phones, setPhone] = useState('')
  const [val, setVal] = useState(phones);
  const [password, setPassword] = useState('')
  const { isAuth, setToken } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  // Password reset modal state
  const [showResetModal, setShowResetModal] = useState(false);

  const login = async () => {
    try {
      // Format phone number if it starts with 0
      let formattedPhone = phones;
      if (phones.startsWith('0')) {
        formattedPhone = "+249" + phones.substring(1);
      }

      const response = await fetch(api_url + "/auth/login", {
        method: "POST",
        body: JSON.stringify({
          phonenumber: formattedPhone,
          password: password
        }),
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (!response.ok) {
        toast.error(t("signin.errors.invalidCredentials"), {
          position: "top-center",
          autoClose: 5000,
        });
        return;
      }

      // Successful login
      setToken(data.access_token);
      localStorage.setItem("auth", "true");
      localStorage.setItem("user_id", data.user_id);
      localStorage.setItem("type", data.type);
      localStorage.setItem("cooperativeType", data.cooperativeType);
      localStorage.setItem("isVerified", data.isVerified);

      if (location.state?.from) {
        navigate(location.state.from)
      }
      window.location.reload();

    } catch (error) {
      toast.error(t("signin.errors.loginError"), {
        position: "top-center",
        autoClose: 5000,
      });
      console.error("Login error:", error);
    }
  };

  // Handle forget password - show modal
  const handleForgetPassword = () => {
    setShowResetModal(true);
  };

  if (isAuth) {
    return <Navigate replace to="/"></Navigate>
  }

  return (
    <>
      <Helmet>
        <title>{t("signin.meta.title")}</title>
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content={t("signin.meta.keywords")} />
        <meta property="og:title" content={t("signin.meta.title")} />
        <meta property="og:description" content={t("signin.meta.description")} />
        <meta property="og:locale" content={i18n.language === 'ar' ? 'ar_SA' : 'en_US'} />
        <meta property="og:type" content="website" />
      </Helmet>
      
      <div className="flex bg-flipped-background bg-no-repeat bg-right-bottom bg-60% lg:bg-50%">
        <div className="hidden lg:block">
          <img src={main} alt={t("signin.heroAlt")} className="h-screen" />
        </div>

        <div className="w-full lg:w-auto lg:mx-auto">
          <div className="flex flex-col p-4 lg:p-0 lg:w-[26.313rem] gap-3 items-center justify-center h-screen mx-auto">
            <img src={logo} alt={t("signin.logoAlt")} className="w-16" />
            <div className="font-bold italic">
              {t("signin.tagline")}
            </div>

            <div className=""></div>
            <div className="flex flex-col text-right justify-center w-full lg:w-[26.313rem]">
              <form id="phone" action="" className="flex flex-col gap-3 mb-3">
                <label className="font-bold">{t("signin.phoneNumber")}</label>
                <input
                  className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0 focus:border-primary"
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  pattern="[+]*?[0-9]*"
                  value={val}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    setVal((v) =>
                      e.target.validity.valid ? e.target.value : v
                    );
                  }}
                  placeholder={t("signin.phonePlaceholder")}
                  type="text"
                />
              </form>
              <form id="phone" action="" className="flex flex-col gap-3">
                <label className="font-bold">{t("signin.password")}</label>
                <input
                  className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0 focus:border-primary"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t("signin.passwordPlaceholder")}
                  type="password"
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                />

                {/* Forget Password Link */}
                <div className="text-left mt-2">
                  <button
                    type="button"
                    onClick={handleForgetPassword}
                    className="text-primary hover:text-blue-700 text-sm font-medium underline transition-colors duration-200"
                  >
                    {t("signin.forgotPassword")}
                  </button>
                </div>
              </form>
              <button
                onClick={() => login()}
                className="w-full h-[47px] font-bold text-white rounded-[13.539px] bg-primary hover:bg-blue-700 transition-colors"
              >
                {t("signin.loginButton")}
              </button>
            </div>

            <div className="relative flex flex-col w-full text-center gap-3">
              <p className="text-[#999797] text-sm">{t("signin.noAccount")}</p>
              <Link to="/signup">
                <button className="w-full h-[47px] font-bold text-primary border-primary border-2 rounded-[13.539px] hover:bg-primary hover:text-white transition-colors">
                  {t("signin.createAccount")}
                </button>
              </Link>
              <p className="text-[#999797] text-sm">{t("signin.or")}</p>
              <Link to="/">
                <button className="w-full h-[47px] font-bold text-primary border-primary border-2 rounded-[13.539px] hover:bg-primary hover:text-white transition-colors">
                  {t("signin.guestLogin")}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Password Reset Modal */}
      <PasswordResetModal
        isOpen={showResetModal}
        onClose={() => setShowResetModal(false)}
        initialPhone={phones}
      />
    </>
  );
}

export default Signin;